import { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { VStack , HStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import LoaderIndicator from "../components/loader_indicator";

import FiltersGrid from "../components/filters_grid";
import TableData  from "../components/pdz_page/table_data";

const PDZPage = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.getAllManagers();
    pageStore.getAllDepartments();
    pageStore.getAllPartners();
    pageStore.getAllAccountNumbers();
    pageStore.getAllBackups();
    pageStore.resetFilters();
  }, []);

  useEffect(() => {
    pageStore.updateSelectedPage("/pdz");
  }, []);

  console.log("email", pageStore.email);

  return (
    <VStack width={"100%"} align={"flex-start"}>

      <HStack
        width="100%"
        spacing="15px"
        wrap="wrap"
        padding="0 20px"
        marginTop="20px"
        justify="center"
      >
        <FiltersGrid
          page="pdz"
          renderButtons={(buttons) => buttons}
        />

        <TableData
          data={pageStore.data_pdz}
          renderButtons={(buttons) => buttons}
        />
      </HStack>
    </VStack>
  );
});

export default PDZPage;
